var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.046 17.6763V13.7583C10.046 13.2035 10.046 12.9261 9.99596 12.6588C9.95155 12.4216 9.878 12.1908 9.77699 11.9716C9.66317 11.7246 9.50269 11.4983 9.18174 11.0458L5.93453 6.4672C5.36882 5.66954 5.08596 5.27071 5.09907 4.93838C5.11048 4.64902 5.24968 4.37964 5.4791 4.20294C5.7426 4 6.23155 4 7.20945 4H16.7901C17.768 4 18.2569 4 18.5204 4.20294C18.7498 4.37964 18.889 4.64902 18.9004 4.93838C18.9135 5.27071 18.6307 5.66954 18.065 6.4672L14.8178 11.0458C14.4968 11.4983 14.3363 11.7246 14.2225 11.9716C14.1215 12.1908 14.048 12.4216 14.0035 12.6588C13.9535 12.9261 13.9535 13.2035 13.9535 13.7583V19.63M10.046 17.6763C11.7002 16.9443 13.9535 17.3804 13.9535 19.63M10.046 17.6763C10.0132 19.9109 12.3079 20.4675 13.9535 19.63",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.6cb6e1d360cf057171c1f4a8bde591c9.svg";
export { ForwardRef as ReactComponent };